module.exports = __webpack_public_path__ + "static/media/warning.ab17029b.png";